function getRatingDescription(rating: number): string {
  const ratingsMap: { [key: number]: string } = {
    1: '1 (Poor)',
    2: '2 (Fair)',
    3: '3 (Average)',
    4: '4 (Good)',
    5: '5 (Excellent)',
  };

  return ratingsMap[rating] || 'Unknown Rating';
}

export { getRatingDescription };
